module.exports = __webpack_public_path__ + "static/media/imgs_50.6ee0e586.jpg";